export default "__VITE_ASSET__BplosyyQ__"